import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { groupActions, participantActions } from '../../../redux/actions';
import Loading from '../../../shared/common/Loading';
import FormGroup from './FormGroup';

const FormAddGroup = () => {
    
    // REDUX
    const dispatch = useDispatch();
    const ondemand_id = useSelector(state => state.user.user.id);
    const loadingNewGroup = useSelector(state => state.group.loadingNewGroup);
    const participants = useSelector(state => state.participant.participants);
    const loadingParticipants = useSelector(state => state.participant.loadingParticipants);

    //EFECT
    useEffect(() => {
        if (participants === null) {
            dispatch(participantActions.getParticipantsRequest({ ondemand_id }));
        }
    }, []);

    //STATE
    const [search, setSearch] = useState('');
    const [nombre, setNombre] = useState('');
    const [checkedItems, setCheckedItems] = useState([]);
    const [idLeader, setIdLeader] = useState('');

    // FUNCTIONS
    function handleSearch(e) {
        setSearch(e.target.value);
    }

    function handleName(e) {
        setNombre(e.target.value);
    }

    const setLider = leader => {
        setIdLeader(leader);
    };

    function handleChecked(e) {
        if (e.target.checked) {
            setCheckedItems([...checkedItems, { id: Number(e.target.name) }]);
        } else {
            setCheckedItems(checkedItems.filter(x => x.id !== Number(e.target.name)));
        }
    }

    function handleAllChecked(e) {
        if (e.target.checked) {
            setCheckedItems(participants.map(p => ({ id: p.participante_id })));
        } else {
            setCheckedItems([]);
        }
    }

    function handleSubmit(e) {
        e.preventDefault();
        dispatch(
            groupActions.createGroupRequest({
                newGroup: {
                    data_grupo: {
                        nombre,
                        group_leader_id: idLeader,
                    },
                    data_participantes: checkedItems,
                },
                ondemand_id,
            }),
        );
    }

    // RETURN

    if (participants === null || loadingParticipants) {
        return <Loading padding="5rem" />;
    }
    return (
        <FormGroup
            type={'add'}
            handleSubmit={handleSubmit}
            handleName={handleName}
            group={null}
            name={nombre}
            setLider={setLider}
            participants={participants}
            handleSearch={handleSearch}
            search={search}
            handleAllChecked={handleAllChecked}
            handleChecked={handleChecked}
            checkedItems={checkedItems}
            loading={loadingNewGroup}
        />
    );
};

export default FormAddGroup;
